module.exports = __webpack_public_path__ + "img/材料力学6_9_2.755a6f67.jpg";